var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.visible, width: "1152px", "append-to-body": "" },
      on: { "update:visible": _vm.changeShow, closed: _vm.closedDialog },
    },
    [
      _c(
        "div",
        { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
        [
          _c("span", { attrs: { title: _vm.data.title } }, [
            _vm._v(_vm._s(_vm.data.title)),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "info_box" },
        [
          _c("div", { staticClass: "fx" }, [
            _c("span", { staticClass: "fx-full source-text" }, [
              _vm._v("发文机关：" + _vm._s(_vm.data.releaseOrganization)),
            ]),
            _c("span", { staticClass: "fx-none title-right source-text" }, [
              _vm._v(_vm._s(_vm.data.releaseDate)),
            ]),
          ]),
          _vm.hasKeywords
            ? _c(
                "div",
                { staticClass: "tag-panel mt-16" },
                [
                  _c("span", [_vm._v("政策关键词：")]),
                  _vm._l((_vm.data || {}).tags, function (item) {
                    return _c(
                      "span",
                      { key: item, staticClass: "policy-tag" },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _c("div", { staticClass: "mt-16" }, [_vm._v("政策原文：")]),
          _c("div", { staticClass: "mt-16 policy-text" }, [
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.data.rawContent) },
            }),
          ]),
          _vm.data.url
            ? _c(
                "el-link",
                {
                  staticClass: "mt-16",
                  attrs: {
                    href: _vm.data.url,
                    type: "primary",
                    target: "_blank",
                  },
                },
                [_vm._v("查看原文")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }